import http from '../util/http';

export const getPageInfo = async (params, isMock) => {
  const res = await http.post(http.baseURL + 'index.php?r=page/info', params, isMock);
  return res;
}